import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import AboutPage from "./Components/AboutPage/AboutPage";
import BlogDetailPage from "./Components/BlogsSection/BlogDetail";
import PaymentSuccess from "./Components/CheckoutPages/PaymentSuccess";
import ContactPage from "./Components/ContactPage/ContactPage";
import CustomerProfilePage from "./Components/CustomerProfilePage/CustomerProfilePage";
import ViewAllOrders from "./Components/CustomerProfilePage/ViewAllOrders";
import FaqPage from "./Components/FAQ/FaqPage";
import Footer from "./Components/Footer/Footer";
import GoToTop from "./Components/GoToTop/GoToTop";
import ViewInvoiceForm from "./Components/Invoices/ViewInvoiceForm";
import FixedNavbar from "./Components/MainNavabar/FixedNavbar";
import PageNotFound from "./Components/PageNotFound/PageNotFound";
import ProductDetail from "./Components/ProductDetail/ProductDetail";
import ProductListing from "./Components/ProductListing/ProductListing";
import ProtectedRoutes from "./Components/ProtectedRoutes/ProtectedRoutes";
import StaticPage from "./Components/StaticPage/StaticPage";
import TopBar from "./Components/TopBar/TopBar";
import Provider from "./Helper/Context/Store";
import GetApiCall from "./Helper/GetApi";
import Cart from "./Pages/Cart/Cart";
import Home from "./Pages/Home";

function App() {
  const [staticPages, setStaticPages] = useState([]);
  useEffect(() => {
    GetApiCall.getRequest("GetStaticPagesList").then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setStaticPages(obj1.data);
        }
      })
    );
  }, [])
  return (
    <>
      <Provider>
        <Router>
          {/* <TopBar /> */}
          <FixedNavbar />
          <Switch>
            {staticPages?.map((dat, index) => {
              return (
                <Route
                  path={[dat.fld_route]}
                  key={index}
                  component={StaticPage}
                ></Route>
              );
            })}
            <Route exact path={"/"} component={Home} />
            <Route exact path={"/contact-us"} component={ContactPage} />
            <Route exact path={"/our-story"} component={AboutPage} />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/ct/:categoryname/:verticalid/:categoryid/:subcatid`}
              component={ProductListing}></Route>
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/category/:categoryname/:subcatname`}
              component={ProductListing}></Route>
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/category/:categoryname`}
              component={ProductListing}></Route>
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/ct/:categoryname`}
              component={ProductListing}></Route>
            <Route exact path={`${process.env.PUBLIC_URL}/pct/:productcategoryname`} component={ProductListing} />
            <Route exact path={`${process.env.PUBLIC_URL}/p/:productname`} component={ProductDetail} />
            <Route exact path={"/cart"} component={Cart} />
            <Route exact path={"/customer-profile"} component={CustomerProfilePage} />
            <Route exact path={"/faq"} component={FaqPage} />
            {/* <ProtectedRoutes
              exact
              path={`${process.env.PUBLIC_URL}/paymentsuccess/:txnid`}
              component={PaymentSuccess}
              isAuth={
                localStorage.getItem("CustomerData") == null ? false : true
              }
            /> */}
            <ProtectedRoutes
              exact
              path={"/view-all-orders"}
              component={ViewAllOrders}
              isAuth={
                localStorage.getItem("CustomerData") == null
                  ? false
                  : true
              }
            />
            <Route
              exact
              path={"/paymentsuccess/:txnid"}
              component={PaymentSuccess}
            />
            <Route
              exact
              path={"/view-invoice-form/:id/:orderid"}
              component={ViewInvoiceForm}
            />
            <Route
              exact
              path={"/blog-detail/:title"}
              component={BlogDetailPage}
            />
            <Route component={PageNotFound} />
          </Switch>
          <Footer />
          <GoToTop />
        </Router>
      </Provider>
    </>
  );
}

export default App;
